<template>
  <div class="container__class" v-if="is_same_user || (!is_same_user && items.length)">
    <v-card>
      <v-card-text>
        <div class="loader__class" v-if="loading">
          <v-row>
            <v-col cols="12" sm="3" v-for="i in 4" :key="i">
              <v-skeleton-loader type="card" animation="wave"> </v-skeleton-loader>
            </v-col>
          </v-row>
        </div>
        <div v-else>
          <video-upload-zero v-if="!items.length && is_same_user"></video-upload-zero>
          <video-list
            :items="items"
            :user_id="user_id"
            v-else-if="(!is_same_user && items.length) || is_same_user"
          ></video-list>
        </div>
      </v-card-text>
    </v-card>
    <upload-video></upload-video>
    <video-detail></video-detail>
    <playlist-modal></playlist-modal>
  </div>
</template>
<script>
import helper from "@/helper";
import Axios from "@/api/newAxios";
import apiUrl from "@/common/apiUrl";
import emitterKey from "@/helper/emitterKey";
export default {
  name: "ProfileListing",
  components: {
    VideoUploadZero: () => import("./VideoUploadZero/VideoUploadZero.vue"),
    VideoList: () => import("./VideoList/VideoList.vue"),
    UploadVideo: () => import("../AddVideoData/UploadVideo/UploadVideo.vue"),
    VideoDetail: () => import("../AddVideoData/VideoDetail/VideoModal.vue"),
    PlaylistModal: () => import("../AddVideoData/PlaylistModal/PlaylistModal.vue"),
  },
  props: {
    user_id: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      emitterKey: emitterKey,
      helper: helper,
      loading: false,
      page_info: {
        page_number: 1,
        total_page: 1,
        detail_count: 3,
      },
      items: [],
    };
  },
  computed: {
    is_same_user() {
      return helper.isSameUser(this.user_id);
    },
  },
  watch: {},
  methods: {
    getVideoList() {
      this.loading = true;
      const onSuccess = (res) => {
        this.items = res.data.video_list;
        this.page_info = res.data.page_info;
        this.loading = false;
      };
      const onFailure = () => {
        this.loading = false;
      };
      let params = {};
      params["detail_count"] = this.page_info.detail_count;
      params["page_number"] = this.page_info.page_number;
      params["user_id"] = this.user_id;
      Axios("get", apiUrl.VIDEO_LIST_API, {
        params,
        onSuccess,
        onFailure,
      });
    },
  },
  mounted() {
    this.getVideoList();
    // console.log(helper.isSameUser(this.user_id));
  },
  created() {
    this.eventBus.$on(this.emitterKey.UPDATE_VIDEO_PLAYLIST, () => {
      this.getVideoList();
    });
  },
  beforeDestroy() {
    // this.eventBus.$off(this.emitterKey.UPDATE_VIDEO_PLAYLIST);
  },
};
</script>
<style scoped>
.container__class {
  width: 100%;
}
.loader__class {
  width: 100%;
  overflow-x: scroll;
}
</style>
